import React from 'react';

import { DATA_TABLE_NS }  from '../../const';
import { useTranslation } from 'react-i18next';

import Button            from '@mui/material/Button';
import Dialog            from '@mui/material/Dialog';
import DialogActions     from '@mui/material/DialogActions';
import DialogContent     from '@mui/material/DialogContent';
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle       from '@mui/material/DialogTitle';
import Grid              from '@mui/material/Grid';
import TextField         from '@mui/material/TextField';

import isBlank from 'utils/isBlank';


export default function TopUpDialog({ card, closeDialog, onSubmit }) {

  const { t } = useTranslation(DATA_TABLE_NS, { keyPrefix: 'topUpDialog' });

  const [helperText, setHelperText] = React.useState('');

  const [cardId,      setCardId]      = React.useState(card.cardId);
  const [topUpAmount, setTopUpAmount] = React.useState('');

  function amountValidationMessage(amount) {
    amount = amount.replaceAll(/,/g, '.'); //JS requires dot
    if (amount.split('.').length > 2) {
      return 'Max 1 przecinek';
    } else if (isNaN(amount)) {
      return 'To nie liczba';
    } else if (amount <= 0) {
      return 'Musi być większe niż 0';
    } else if (amount > 9999999) {
      return 'Za duża liczba';
    } else {
      return '';
    }
  }

  function handleSubmit() {
    const amount = topUpAmount.replaceAll(/,/g, '.'); //JS requires dot
    const validationMessage = amountValidationMessage(amount);
    if (validationMessage) {
      alert(validationMessage);
      return;
    }
    const result = {
      cardId:      cardId,
      topUpAmount: parseFloat(amount),
    };
    onSubmit(result);
    closeDialog();
  }

  return (
    <Dialog
      open={true}
      fullWidth={true}
      maxWidth={'sm'}
      onClose={(evt, type) => {
        if (type === 'backdropClick') {
          return; //Don't close on backdrop click
        }
        closeDialog();
      }}
    >
      <DialogTitle>
        {t('title')}
        <DialogContentText>{t('subTitle')}</DialogContentText>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              required
              disabled
              fullWidth
              value={cardId}
              label={t('cardId')}
              onChange={(evt) => setCardId(evt.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              required
              fullWidth
              value={topUpAmount}
              label={t('topUpAmount')}
              onChange={(evt) => {
                let val = evt.target.value;
                //Allow only digits, comma and dot
                val = val.replaceAll(/[^\d,.]/g, '');
                //Make sure that commas are converted to dots
                val = val.replaceAll(/\./g, ','); //Display commas
                setTopUpAmount(val);
                setHelperText(amountValidationMessage(val));
              }}
              error={!isBlank(helperText)}
              helperText={helperText}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          id='submitButton'
          onClick={handleSubmit}
          color='primary'
          variant='contained'
          disabled={!isBlank(helperText)}
        >
          {t('save')}
        </Button>
        <Button
          id="cancelButton"
          onClick={closeDialog}
          color='primary'
          variant='outlined'
        >
          {t('cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
